import axios from 'axios';

import getAuthSession from './auth';
import { Question } from '../interfaces/question.interface';
import { InclusionConfiguration } from '../interfaces/inclusionConfiguration.interface';
import { IncludedInLogic } from '../features/Questions/Question';

const baseUrl = process.env.REACT_APP_BASE_API;

export async function getQuestion(questionId: number) {
  const authSession = await getAuthSession();
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_API}/questions/${questionId}/`,
    {
      headers: { 'Authorization': `Bearer ${authSession.getIdToken().getJwtToken()}` },
    },
  );
  return response.data as Question;
}

export const fetchIncludedInLogic = async (
  questionId: number,
): Promise<IncludedInLogic[] | undefined> => {
  if (!questionId) return;

  const authSession = await getAuthSession();
  const token = authSession.getIdToken().getJwtToken();
  const headers = { Authorization: `Bearer ${token}` };

  const { data: { results: configs } } = await axios.get<{
    results: InclusionConfiguration[];
  }>(
    `${baseUrl}/inclusion-configurations/?question=${questionId}&limit=100`,
    { headers },
  );

  const inclusionCalls = configs.map(cfg =>
    axios.get<{ questions: Question[] }>(
      `${baseUrl}/inclusion-questions/?inclusion_configuration=${cfg.id}&limit=9999`,
      { headers },
    ),
  );
  const inclusionResponses = await Promise.all(inclusionCalls);

  const allQuestions: Question[] = inclusionResponses.flatMap(r => r.data.questions);
  const uniqueMap = new Map<number, IncludedInLogic>();
  allQuestions.forEach(q => {
    if (!uniqueMap.has(q.id)) {
      uniqueMap.set(q.id, { ...q, inclusionIds: [] });
    }
  });

  uniqueMap.forEach(q => {
    q.inclusions.forEach(inc => {
      const incId = typeof inc === 'number' ? inc : inc.id;
      if (configs.some(c => c.id === incId) && !q?.inclusionIds?.includes(incId)) {
        q?.inclusionIds?.push(incId);
      }
    });
  });

  return Array.from(uniqueMap.values());
};

export async function fetchQuestionnaireQuestions(questionnaireId:number) {
  const authSession = await getAuthSession();
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_API}/questions/?questionnaire=${questionnaireId}&limit=99999`,
    {
      headers: {
        'Authorization': `Bearer ${authSession.getIdToken().getJwtToken()}`,
      },
    },
  );
  return (response.data.results) as Question[];
}

export default {};